<template>
  <!-- <router-link
    class="gw_box anim-fade-in_slow"
    style="--box-padding: 0"
    v-if="todaysCoaching"
    :to="{ name: 'Coaching' }"
  > -->
  <div
    v-if="todaysCoaching"
    class="gw_box anim-fade-in_slow"
    style="--box-padding: 0"
  >
    <!-- :to="{ name: 'Coaching' }" -->
    <div class="gw_box gw_box_widget_title">
      {{ $t('common.todays_coaching') }}
      <div class="ml-auto"></div>
      <!-- <div
        class="mdi mdi-chevron-right clr-white ml-auto text-large line-height_1 pa-1 icon_btn csst csst_nm"
      >
        <div
          class="csst_content text-nowrap"
          style="left: -0.25em; transform: translate(-100%, 0)"
          v-html="$t('btn.see_more')"
        ></div>
      </div> -->
    </div>
    <FutureCoachingsBox
      :item="todaysCoaching"
      class="dashboardstats_hover-overlay"
      style="--padding: 2rem; --gap: 2rem; --btn-flex: 1"
    />

    <!-- l_item.in_progress -->
    <!-- l_item.available_to_user -->

    <!-- <div
      class="clr-white f-center text-semi-large weight_600"
      style="position: absolute; top: -0.75rem; left: 1rem"
    >
      <div class="mr-2 f-center" style="min-width: 1.325rem">
        <Logo style="fill: currentColor" />
      </div>
      <div
        class="position-relative"
        v-html="$t('common.todays_coaching')"
      ></div>
    </div> -->
  </div>
  <!-- </router-link> -->
</template>

<script>
import FutureCoachingsBox from '@/components/lib/FutureCoachingsBox'
import { getMappedCoachingItem } from '@/helpers/coachings'

export default {
  name: 'FutureCoaching',
  components: {
    FutureCoachingsBox,
    // Logo,
  },
  props: {},
  data() {
    return {}
  },
  created() {
    this.$store.dispatch('api_coachings')
  },

  computed: {
    videoList() {
      return (this.$store.getters.api_get_data('api_coachings') || []).filter(i => i?.coach)
    },
    todaysCoaching() {
      const vids = this.videoList.map((item, idx) => {
        const r = getMappedCoachingItem({
          item,
          locale: this.$i18n.locale,
        })
        return r
      })
      const todaysVid = vids.find(i => i.is_today)
      return import.meta.env.VITE_BRANCH === 'master' ? todaysVid : vids[0]
    },
  },
}
</script>

<style lang="scss">
// @media (hover: hover) and (pointer: fine) {
//   .dashboardstats_hover-overlay {
//     &::before {
//       content: '';
//       // background: rgba(255, 255, 255, 0.05);
//       background: var(--clr-black-1-3);
//       height: calc(100% - 1rem);
//       width: calc(100% - 1rem);
//       left: 0.5rem;
//       top: 0.5rem;
//       // left: 0;
//       position: absolute;
//       border-radius: 4px;
//       overflow: hidden;
//       z-index: 0;
//       opacity: 0;
//       transition: opacity 0.2s ease;
//     }
//     &:hover {
//       &::before {
//         opacity: 1;
//       }
//     }
//   }
// }
</style>
